// extracted by mini-css-extract-plugin
module.exports = {"terms":"Terms_terms__1-9nc","terms__content":"Terms_terms__content__3u40W","terms__foot":"Terms_terms__foot__1Qes2"};